var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as actions from '../constants/actionTypes';
var list = handleActions((_a = {},
    _a[actions.addSnackBar.type.REQUEST] = function (state, _a) {
        var payload = _a.payload;
        return __spreadArray(__spreadArray([], state, true), [
            payload,
        ], false);
    },
    _a), []);
export default combineReducers({
    list: list,
});
//# sourceMappingURL=snackBar.js.map